/**
 * Hiển thị ô dữ liệu: ô chưa có thông tin để TRỐNG, không ghi "0", "—", "undefined", "null", "NaN".
 * Dùng cho báo giá, trang PO và bản in.
 */
const BLANK_TEXT = new Set(['', 'null', 'undefined', 'NaN', '—'])

/** Giá trị coi như chưa có thông tin. */
export function isBlankCell(value: unknown): boolean {
  if (value === null || value === undefined) return true
  if (typeof value === 'number') return !Number.isFinite(value)
  if (typeof value === 'string') return BLANK_TEXT.has(value.trim())
  return false
}

/** Chữ hiển thị trong ô: rỗng nếu chưa có thông tin, còn lại giữ nguyên dạng ghi. */
export function displayCell(value: unknown): string {
  if (isBlankCell(value)) return ''
  if (typeof value === 'boolean') return value ? 'Có' : 'Không'
  return String(value).trim()
}
